<template>
  <div style="display: contents">
    <SampleDescriptionGrid :dv="dv" />
    <SamplePreparation :dv="dv" />
    <SampleLineageDescription :dv="dv" />
    <ControlSample
      v-if="showControlSection"
      :dv="dv"
      :validation-errors="validationErrors"
    />
    <SingleCellSample
      v-if="showSingleCellSection"
      :dv="dv"
      :validation-errors="validationErrors"
      :hidden-fields="hiddenFields"
    />
    <SamplePlate
      v-if="showPlateSection"
      :dv="dv"
      :validation-errors="validationErrors"
    />
    <SampleLinkToELN :dv="dv" />
  </div>
</template>

<script>
import { useGenericSampleValidation } from '@/composables/validation/sample/useSampleValidation'
import SampleDescriptionGrid from './shared/SampleDescriptionGrid.vue'
import SamplePreparation from './shared/SamplePreparation.vue'
import SampleLineageDescription from './shared/SampleLineageDescription.vue'
import ControlSample from './shared/ControlSample.vue'
import SingleCellSample from './shared/SingleCellSample.vue'
import SamplePlate from './shared/SamplePlate.vue'
import SampleLinkToELN from './shared/SampleLinkToELN.vue'

export default {
  name: 'GenericSample',
  components: {
    SampleDescriptionGrid,
    SamplePreparation,
    SampleLineageDescription,
    ControlSample,
    SingleCellSample,
    SamplePlate,
    SampleLinkToELN,
  },
  props: {
    dv: { type: Object, required: true },
  },
  setup(props) {
    const {
      showControlSection,
      showSingleCellSection,
      showPlateSection,
      validationErrors,
      hiddenFields,
    } = useGenericSampleValidation(props.dv)

    return {
      showControlSection,
      showSingleCellSection,
      showPlateSection,
      validationErrors,
      hiddenFields,
    }
  },
}
</script>
